import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactPanelComponent } from './contact-panel.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ContactPanelItemModule } from './components/contact-panel-item/contact-panel-item.module';

@NgModule({
  declarations: [ContactPanelComponent],
  exports: [ContactPanelComponent],
  imports: [
    CommonModule,
    SharedModule,
    ContactPanelItemModule
  ],
})
export class ContactPanelModule { }
